import useFavicon from "hooks/useFavicon";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { isInternetExplorer } from "utils/browser";
import { setMetaDescription } from "utils/dom";
import Footer from "../Footer";
import UnsupportedBrowserPage from "../UnsupportedBrowserPage";
import Head from "./Head";

const EnforcerPage: React.FC = () => {
  const { t } = useTranslation();

  useFavicon("/favicon-enforcer.svg");

  useEffect(() => {
    document.title = t("10717"); /* iParque Enforcer –  App de Fiscalização */

    setMetaDescription(
      t(
        "10718"
      ) /* Uma app para monitorização e gestão de estacionamentos em tempo real. A pensar nos agentes de fiscalização! */
    );

    return () => {
      document.title =
        t(
          "10694"
        ) /* iParque OnStreet – Gestão de Estacionamento para concessionárias */;

      setMetaDescription(
        t(
          "10695"
        ) /* Controlo e monitorização de zonas, ruas e equipas de fiscalização. A solução para a sua concessionária! */
      );
    };
  }, [t]);

  return isInternetExplorer ? (
    <UnsupportedBrowserPage />
  ) : (
    <>
      <Head />
      <Footer modulesURL="/" />
    </>
  );
};

export default EnforcerPage;
